import { render, staticRenderFns } from "./SSelectPaymentterms.vue?vue&type=template&id=49046aac"
import script from "./SSelectPaymentterms.vue?vue&type=script&lang=js"
export * from "./SSelectPaymentterms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports